module.exports = __webpack_public_path__ + "static/media/shortness-of-breath-copy.323bd917.svg";